module.exports = __webpack_public_path__ + "img/papel.21107320.png";